<template>
    <div>
        <div v-if="bookingFailed" class="card mt-2">
            <div class="card-header">SORRY FOR THE BOTHER</div>
            <div class="card-body">
                <p class="card-text">We are sorry but we have been unable to take your booking, technology has beaten us this time!</p>
                <p class="card-text">Please get in touch with us either via <a :href="mailTo">email</a> or by giving us a <a :href="tel">call</a> and we'll be happy to help you with your visit to the Real Ireland.</p>
                <p class="card-text">Thanks again for your interest, and we do hope to welcome you to the our shores soon.</p>
            </div>
        </div>
        <div v-if="!bookingFailed && !paymentFailed" class="card mt-2">
            <div class="card-header">THANK YOU FOR YOUR PAYMENT</div>
            <div class="card-body">
                <p class="card-text">Your booking is complete and we have received payment of {{ amountPaid }}.</p>
                <p class="card-text">Please keep a note of your booking reference <strong>{{ bookingRef }}</strong>, you will receive a confirmation email and receipt for your payment shortly.<p>
                <p class="card-text"><em>If your confirmation email or receipt don't arrive within a few minutes then it is worth checking your spam or junk folder.</em></p>     
                <p class="card-text">We will be in touch in due course with your confirmed itinerary documents.</p>
                <p class="card-text">We look forward to welcoming you to <strong><em>{{ countyName }}</em></strong></p>
            </div>
        </div>
        <div v-if="!bookingFailed && paymentFailed" class="card mt-2">
            <div class="card-header">THANK YOU FOR YOUR BOOKING</div>
            <div class="card-body">
                <p class="card-text">Your booking is complete, but unfortunately there was a problem with your payment.</p>
                <p class="card-text">Please keep a note of your booking reference <strong>{{ bookingRef }}</strong>, you will receive a confirmation email shortly and we will be in touch to arrange payment.<p>
                <p class="card-text"><em>If your confirmation email doesn't arrive within a few minutes then it is worth checking your spam or junk folder.</em></p>
                <p class="card-text">Please note that as per our terms and conditions your booking is not confirmed until we have received payment and confirmed services with our suppliers.</p>
                <p class="card-text">We look forward to welcoming you to <strong><em>{{ countyName }}</em></strong></p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState({
            bookingRequestId: state => state.booking.bookingRequestId,
            amountPaid: state => state.dayByDay.pricing.amountToPayFormatted,
            countyName: state => state.start.selectedCounty.name,
            bookingFailed: state => state.booking.bookingFailed,
            paymentFailed: state => state.booking.paymentFailed,
        }),
        ...mapGetters([ 'bookingRef' ]),
        mailTo() { return `mailto:${process.env.VUE_APP_CONTACT_EMAIL}` },
        tel() { return `tel:${process.env.VUE_APP_CONTACT_PHONE}` },
    }    
}
</script>